import AppConstants from '../../config/app.constants';

class VaultOperationsController {
    /*@ngInject*/
    constructor(Auth, User, Modal, SetupService, Navigation, $q, $translate, DateUtil, $rootScope, TimezoneList, UsersService,
        VaultOperationsService, DataCounter, $state, RouteDetailService, ShipmentService, HoldService, UserBranchService, CommonLayoutService) {
        this.Auth = Auth;
        this.User = User;
        this.Modal = Modal;
        this.SetupService = SetupService;
        this.Navigation = Navigation;
        this.$q = $q;
        this.$translate = $translate;
        this.DateUtil = DateUtil;
        this.$rootScope = $rootScope;
        this.TimezoneList = TimezoneList;
        this.UsersService = UsersService;
        this.VaultOperationsService = VaultOperationsService;
        this.DataCounter = DataCounter;
        this.$state = $state;
        this.RouteDetailService = RouteDetailService;
        this.ShipmentService = ShipmentService;
        this.HoldService = HoldService;
        this.UserBranchService = UserBranchService;
        this.CommonLayoutService = CommonLayoutService;
        this.initialSearchFocusApplied = false;

        this.model = {
            branchObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingBranch: false,
                searchText: null,
            },
            routesObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingRoutes: false,
                searchText: null,
                sortColumn: 'routeDate',
                reverseSort: true
            },
            loadShipmentObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingLoadShipment: false,
                searchText: null,
                sortColumn: 'vaultDate',
                reverseSort: true
            },
            residualShipmentObj: {
                results: [],
                totalRecords: 0,
                pagination: {
                    page: 1,
                    total: 0,
                    pageLimit: 10,
                    maxPages: 10
                },
                gettingResidualShipment: false,
                searchText: null,
                sortColumn: 'vaultDate',
                reverseSort: true
            },
            loggedInUser: User.getUser().id,
            currentBranch: User.getUser().branchId,
            loading: false,
            dateRangeOptions: {
                startDate: null,
                endDate: null,
            },
            dateRangPickerOptions: {},
            dateRangPickerOptionsfor: {},
            timezone: null,
            timezoneList: this.TimezoneList.getTimezoneList(),
            browserTimezone: moment.tz.guess(),
            selectedBranch: '',
            userBranchList: []
        };

        this.$rootScope.$broadcast('routeChange', '/app/vault-operations');
    }

    $onInit() {
        this.$q.all([
            this.SetupService.get(this.model.currentBranch),
            this.UsersService.getUserFieldData(this.model.loggedInUser),
            this.UserBranchService.getUserBranches(this.model.loggedInUser),
            this.getSoftDeleteShipmentPermission()
        ])
            .then((data) => {
                this.model.setupDetails = data[0];
                this.model.userDetails = data[1];
                this.model.branchObj.results = data[2].results;
                this.model.branchObj.results.forEach((branch) => {
                    if (branch.branchId == this.model.currentBranch) {
                        branch.ticked = true;
                    }
                })
                this.currentVaultDate = this.DateUtil.getUTCDate(this.model.setupDetails.currentVaultDate);
                this.model.timezone = (this.model.userDetails && this.model.userDetails.timezone) ? this.model.userDetails.timezone : this.model.browserTimezone;;

                this.setDateRangeOptions('dateRangPickerOptionsfor');
                this.model.dateRangeOptions.startDate = moment().startOf('day').format('YYYY-MM-DD HH:mm:ss');
                this.model.dateRangeOptions.endDate = moment().endOf('day').format('YYYY-MM-DD HH:mm:ss');
            })
            .then(() => {
                this.loadData();
            })
            .catch((err) => {
                console.log(err);
            });
    }

    setDateRangeOptions(modelValue) {
        this.model[modelValue] = {
            autoApply: true,
            eventHandlers: {
                'apply.daterangepicker': () => {
                    this.loadData();
                }
            },
            ranges: {
                'Previous Week': [
                    moment().subtract(7, 'days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().subtract(1, 'day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Today': [
                    moment().startOf('day').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Week': [
                    moment().startOf('week').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('week').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Current Month': [
                    moment().startOf('month').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('month').format('YYYY-MM-DD HH:mm:ss')
                ],
                'Last 60 Days': [
                    moment().subtract('59','days').format('YYYY-MM-DD HH:mm:ss'),
                    moment().endOf('day').format('YYYY-MM-DD HH:mm:ss')
                ],
            }
        }
    }

    getStartDate() {
        return this.model.dateRangeOptions.startDate ? moment(this.model.dateRangeOptions.startDate).format('YYYY-MM-DD') : null;
    }

    getEndDate() {
        return this.model.dateRangeOptions.endDate ? moment(this.model.dateRangeOptions.endDate).format('YYYY-MM-DD') : null;
    }

    // -------------------------------------------route List Logic section Start------------------------------------------------ //

    getRouteList() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const branches = this.getSelectedBranches();
            const getRoutesOnVaultDate = null;

            this.model.routesObj.gettingRoutes = true;
            this.VaultOperationsService.getRouteList(this.model.routesObj.searchText, startDate, endDate,
                (this.model.routesObj.pagination.page - 1) * this.model.routesObj.pagination.pageLimit, this.model.routesObj.pagination.pageLimit,
                this.model.routesObj.reverseSort, this.model.routesObj.sortColumn, this.model.timezone, getRoutesOnVaultDate, branches)
                .then((data) => {
                    this.model.routesObj.pagination.total = data.totalRecords;
                    this.model.routesObj.results = data.results;
                    this.model.routesObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    console.log(err);
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.routesObj.gettingRoutes = false;
                    this.focusFirstAvailableSearch();
                })
        });
    }

    focusFirstAvailableSearch() {
        if (this.initialSearchFocusApplied) return;
        if (this.model.routesObj.gettingRoutes || this.model.loadShipmentObj.gettingLoadShipment || this.model.residualShipmentObj.gettingResidualShipment) {
            return;
        }
        this.initialSearchFocusApplied = true;

        let targetId = 'routeSearchText';
        if (this.model.routesObj.results && this.model.routesObj.results.length) {
            targetId = 'routeSearchText';
        } else if (this.model.loadShipmentObj.results && this.model.loadShipmentObj.results.length) {
            targetId = 'loadShipmentSearchText';
        } else if (this.model.residualShipmentObj.results && this.model.residualShipmentObj.results.length) {
            targetId = 'residualShipmentSearchText';
        }

        setTimeout(() => {
            const el = document.getElementById(targetId);
            if (el) el.focus();
        }, 300);
    }

    loadData() {
        this.model.routesObj.pagination.page = 1;
        this.model.loadShipmentObj.pagination.page = 1;
        this.model.residualShipmentObj.pagination.page = 1;

        this.getRouteList();
        this.getDeliveryShipmentList();
        this.getPickupShipmentList();
    }

    goToRouteTab(data) {
        const date = data.hasOwnProperty('routeDate') ? data.routeDate : data.vaultDate;

        if (this.model.currentBranch === data.branchId) {
            this.redirectToRouteTab(data.routeId, date);
        }
        else {
            this.shiftBranch(this.model.loggedInUser, data.branchId)
                .then(() => {
                    setTimeout(() => {
                        this.redirectToRouteTab(data.routeId, date);
                    }, 500);
                })
                .catch((err) => {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                    this.Modal.errorModal(this.errorMessage);
                });
        }
    }

    redirectToRouteTab(routeId, branchVaultDate) {
        return this.Navigation.goToRouteTab(routeId, branchVaultDate, true, null);
    }

    pageChange(stats) {
        if (stats === 'routes') return this.getRouteList();
        else if (stats === 'loadShipments') return this.getDeliveryShipmentList();
        else if (stats === 'pickupShipments') return this.getPickupShipmentList();
    }

    goToUserTab(userId) {
        if (!userId) return;
        this.Navigation.goToUserTab(userId, null);
    }

    goToVehicleTab(vehicleId) {
        if (!vehicleId) return;
        this.Navigation.goToVehicleTab(vehicleId, null);
    }

    sortRouteData(column, event) {
        this.model.routesObj.reverseSort = (this.model.routesObj.sortColumn == column) ? !this.model.routesObj.reverseSort : false;
        this.model.routesObj.sortColumn = column;
        this.getRouteList();
        event.preventDefault();
    }

    editRouteDetails(routeObj) {
        if (this.isLoading) return;
        this.isLoading = true;

        const date = this.DateUtil.getUTCDate(routeObj.routeDate);
        // const timezone = this.model.timezone || this.model.setupDetails.timezone;
        // routeObj.timezone = timezone;

        this.Modal.routesInfoModal(routeObj, true, ({ truck, messenger, modal, leaveTime, arriveTime, complTime, begMiles, endMiles, supervisorId }) => {
            this.VaultOperationsService.updateRouteDetails(routeObj.branchId, routeObj.routeId, date, truck, messenger, null, null, leaveTime, 
                                                           arriveTime, complTime, begMiles, endMiles, this.model.timezone, supervisorId)
                .then(() => {
                    this.getRouteList();
                    this.isLoading = false;
                    modal.close();
                }).catch((err) => {
                    this.isLoading = false;
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal("error." + err.data.message);
                    }
                })
        }, ({ modal }) => {
            this.isLoading = false;
            modal.close();
        })
    }

    resetData() { }

    filterRouteList() {
        this.model.routesObj.pagination.page = 1;
        this.getRouteList();
    }

    goToItemHistory(data) {
        if (this.model.currentBranch === data.branchId) {
            this.redirectToItemHistory(data.trackingId);
        }
        else {
            this.shiftBranch(this.model.loggedInUser, data.branchId)
                .then(() => {
                    setTimeout(() => {
                        this.redirectToItemHistory(data.trackingId);
                    }, 500);
                })
                .catch((err) => {
                    err.data.errors.map((e) => {
                        this.errorMessage += e.message + '<br/>'
                    })
                    this.Modal.errorModal(this.errorMessage);
                });
        }
    }

    redirectToItemHistory(trackingId) {
        this.$state.go('branchManagement.items', {
            id: trackingId,
        });
    }

    // -------------------------------------------route List Logic section End------------------------------------------------ //

    // -------------------------------------------Delivery Shipment Logic section Start------------------------------------------------ //

    getDeliveryShipmentList() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const branches = this.getSelectedBranches();

            this.model.loadShipmentObj.gettingLoadShipment = true;

            this.VaultOperationsService.getDeliveryShipmentList(this.model.loadShipmentObj.searchText, startDate, endDate,
                (this.model.loadShipmentObj.pagination.page - 1) * this.model.loadShipmentObj.pagination.pageLimit, this.model.loadShipmentObj.pagination.pageLimit,
                this.model.loadShipmentObj.reverseSort, this.model.loadShipmentObj.sortColumn, this.model.timezone, branches)
                .then((data) => {
                    this.model.loadShipmentObj.pagination.total = data.totalRecords;
                    this.model.loadShipmentObj.results = data.results;
                    this.model.loadShipmentObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.loadShipmentObj.gettingLoadShipment = false;
                    this.focusFirstAvailableSearch();
                })
        });
    }

    goToServiceHistory(locationId) {
        return this.Navigation.goToServiceHistory(locationId, null, true, null);
    }

    getOrderType(type) {
        if (!type) return;
        return this.ShipmentService.getOrderType(type);
    }

    translateStatus(statusCode) {
        return this.$translate.instant(statusCode);
    }

    sortDeliveryShipmentData(column, event) {
        this.model.loadShipmentObj.reverseSort = (this.model.loadShipmentObj.sortColumn == column) ? !this.model.loadShipmentObj.reverseSort : false;
        this.model.loadShipmentObj.sortColumn = column;
        this.getDeliveryShipmentList();
        event.preventDefault();
    }

    filterDeliveries() {
        this.model.loadShipmentObj.pagination.page = 1;
        this.getDeliveryShipmentList();
    }

    markAsDelivered(shipment, stats) {
        if (this.loading) return;
        this.loading = true;

        const date = this.DateUtil.getUTCDate(shipment.vaultDate);

        this.Modal.markAsDelivered(shipment, date, this.model.timezone, ({ modal, supervisorId, comment, loadedAmount, date, time }) => {
            this.HoldService.shipmentDelivery(shipment.trackingId, shipment.routeId, supervisorId, comment, shipment.branchId,
                loadedAmount, date, time, this.model.timezone, shipment.orderType, shipment.amount)
                .then(() => {
                    modal.close();
                    if (stats === 'Pickups') {
                        this.filterPickupShipment();
                    }
                    else {
                        this.getDeliveryShipmentList();
                    }
                })
                .catch((err) => {
                    modal.close();
                    this.Modal.errorModal('error.' + err.data.message)
                })
                .finally(() => {
                    this.loading = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
            this.loading = false;
        })
    }

    sendToHold(shipment) {
        let reason = '', comments = 'send to hold';

        const date = this.DateUtil.getUTCDate(shipment.vaultDate);

        this.Modal.confirmSupervisor('send-to-hold', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
            this.ShipmentService.holdShipment(shipment.branchId, shipment.trackingId, shipment.routeId, date, supId, reason, comments)
                .then(() => {
                    modal.close();
                    this.getDeliveryShipmentList();
                    if(this.isParentResidualPickup(shipment)) this.getPickupShipmentList();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal("error." + err.data.message);
                    }
                })
        }, ({ modal }) => {
            modal.close();
        })
    }

    editLoadShipmentModal(shipmentObj) {
        const branchTimezone = this.model.timezone || this.model.setupDetails.timezone;
        this.Modal.editDeliveryShipment(shipmentObj, branchTimezone, ({ modal, shipments,updateState, $scope }) => {

            delete shipments.amount;
            delete shipments.deliveryTime;
            delete shipments.deliveryDate;
            delete shipments.vaultDate;
            delete shipments.loadedAmount;
            delete shipments.selectedRoute;
            shipments.currentTimezone = this.model.timezone;

            $scope.model.loading = true;
            if(shipments.status === "shipment.hold" && updateState === "mark_delivered"){
                this.VaultOperationsService.markHoldAsDelivered(shipments)
                .then(() => {
                    modal.close();
                    this.getDeliveryShipmentList();
                })
                .catch((err) => {
                    modal.close();
                    this.Modal.errorModal('error.' + err.data.message)
                })
                .finally(() => {
                    $scope.model.loading = false;
                })
            } else {
                this.VaultOperationsService.updateDeliveryShipment(shipments)
                    .then(() => {
                        modal.close();
                        this.getDeliveryShipmentList();
                    })
                    .catch((err) => {
                        modal.close();
                        this.Modal.errorModal('error.' + err.data.message)
                    })
                    .finally(() => {
                        $scope.model.loading = false;
                    })
            }
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    convertToCrv(shipment) {
        this.UsersService.checkSupervisor(this.model.loggedInUser)
            .then((userInfo) => {
                this.Modal.convertToCrv(shipment, !userInfo.supervisor, true, ({ supervisor, trackingIdResidual, modal }) => {
                    if (trackingIdResidual) {
                        return this.HoldService.convertToCRV(shipment.branchId, shipment.trackingId, trackingIdResidual, userInfo.supervisor ? userInfo.id : supervisor)
                            .then(() => {
                                this.getDeliveryShipmentList();
                            })
                            .catch((err) => {
                                if (err && err.data && err.data.message) {
                                    this.Modal.errorModal('error.' + err.data.message);
                                }
                            })
                            .finally(() => {
                                modal.close();
                            })
                    }
                    else {
                        if (modal) modal.close();
                    }
                }, ({ modal }) => {
                    if (modal) modal.close();
                })
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    convertToCrvPackableOrder(shipment) {
        if (this.isLoading) return;
        this.isLoading = true;
        this.Modal.confirm({
          header: 'Confirm CRV Conversion', 
          message: 'Are you sure you want to convert this Shipment to CRV?', 
          callback: ({ modal, $scope }) => {
            modal.close();
            this.UsersService.checkSupervisor(this.model.loggedInUser)
              .then((userInfo) => {
                this.Modal.confirmSupervisor('shipment-hold-convert-CRV', { trackingId: shipment.trackingId }, ({ modal: supModal, supId }) => {
                  supModal.close();
                  const defer = this.$q.defer();
                  this.HoldService.convertToCrvPackableOrder(shipment.branchId, shipment.trackingId, shipment.packableOrderShipmentId, supId)
                    .then((data) => {
                      const totals = this.DataCounter.getCounterForItemHold();
                      this.DataCounter.setCounterForItemHold(totals - 1);
                      defer.resolve(data);
                    })
                    .catch((err) => {
                      if (err && err.data && err.data.message) {
                        this.isLoading = false;
                        this.Modal.errorModal('error.' + err.data.message);
                      }
                    });
          
                  defer.promise
                    .then(() => {
                      this.isLoading = false;
                      this.loadData();
                    });
                }, ({ modal: supModal }) => {
                  supModal.close();
                  this.isLoading = false;
                });
              })
              .catch((err) => {
                this.Modal.errorModal(err.data.message);
                this.isLoading = false;
              });
          },
          negative: ({ modal, $scope }) => {
            modal.close();
            this.isLoading = false;
          }
        });
      }    

    removeHoldShipment(shipment, stats) {
        this.isRemovingFromHold = true;
        this.Modal.confirmSupervisor('remove-from-hold', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
            this.VaultOperationsService.removeHoldShipment(shipment.trackingId, supId, shipment.branchId)
                .then(() => {
                    if (stats === 'Deliveries') {
                        this.filterDeliveries();
                    }
                    else if (stats === 'Pickups') {
                        this.filterPickupShipment();
                    }
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.isRemovingFromHold = false;
                    modal.close();
                })
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isRemovingFromHold = false;
        })
    }

    convertToBagoutablePickup(shipment) {
        if (this.isConvertingToBagout) return;
        this.isConvertingToBagout = true;

        this.Modal.confirmSupervisor('send-to-bagout', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
            this.VaultOperationsService.convertToBagoutablePickup(shipment.trackingId)
                .then(() => {
                    modal.close();
                    this.getDeliveryShipmentList();
                    this.getPickupShipmentList();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.isConvertingToBagout = false;
                });
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isConvertingToBagout = false;
        });
    }

    convertToPickup(shipment) {
        if (this.isConvertingToPickup) return;
        this.isConvertingToPickup = true;

        this.Modal.confirmSupervisor('convert-to-pickup', { trackingId: shipment.trackingId }, ({ modal, supId }) => {
            this.VaultOperationsService.convertToPickup(shipment.trackingId, shipment.branchId, shipment.routeId, supId, this.formatDate(shipment.vaultDate))
                .then(() => {
                    modal.close();
                    this.getDeliveryShipmentList();
                    this.getPickupShipmentList();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.isConvertingToPickup = false;
                });
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isConvertingToPickup = false;
        });
    }

    branchTransfer(shipment, stats) {
        const defer = this.$q.defer();
        this.Modal.branchTransferModal(shipment, ({ modal, selectedBranch, comment, supervisorId, selectedRoute, selectedDate, fromBranchId }) => {
            this.ShipmentService.branchTransfer(selectedBranch, shipment.trackingId, shipment.routeId,
                shipment.vaultDate, supervisorId, comment, selectedRoute, selectedDate, fromBranchId)
                .then((data) => {
                    if (stats === 'Deliveries') {
                        this.getDeliveryShipmentList();
                    } else if (stats === 'Pickups') {
                        this.getPickupShipmentList();
                    }
                    defer.resolve();
                    modal.close();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal('error.' + err.data.message);
                    }
                    defer.reject();
                    modal.close();
                })
        }, ({ modal }) => {
            modal.close();
        })
        return defer.promise;
    }

    // -------------------------------------------Delivery Shipment Logic section End------------------------------------------------ //

    // -------------------------------------------Pickup/Residual Shipment Logic section Start------------------------------------------------ //

    getPickupShipmentList() {
        setTimeout(() => {
            const startDate = this.getStartDate();
            const endDate = this.getEndDate();
            const branches = this.getSelectedBranches();

            this.model.residualShipmentObj.gettingResidualShipment = true;

            this.VaultOperationsService.getPickupShipmentList(this.model.residualShipmentObj.searchText, startDate, endDate,
                (this.model.residualShipmentObj.pagination.page - 1) * this.model.residualShipmentObj.pagination.pageLimit, this.model.residualShipmentObj.pagination.pageLimit,
                this.model.residualShipmentObj.reverseSort, this.model.residualShipmentObj.sortColumn, this.model.timezone, branches)
                .then((data) => {
                    this.model.residualShipmentObj.pagination.total = data.totalRecords;
                    this.model.residualShipmentObj.results = data.results;
                    this.model.residualShipmentObj.totalRecords = data.totalRecords;
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                })
                .finally(() => {
                    this.model.residualShipmentObj.gettingResidualShipment = false;
                    this.focusFirstAvailableSearch();
                })
        })
    }

    sortPickupShipmentData(column, event) {
        this.model.residualShipmentObj.reverseSort = (this.model.residualShipmentObj.sortColumn == column) ? !this.model.residualShipmentObj.reverseSort : false;
        this.model.residualShipmentObj.sortColumn = column;
        this.getPickupShipmentList();
        event.preventDefault();
    }

    filterPickupShipment() {
        this.model.residualShipmentObj.pagination.page = 1;
        this.getPickupShipmentList();
    }

    makeDeliverablePickup(shipment) {
        shipment.date = shipment.vaultDate;
        this.Modal.makeDeliverable(shipment, ({ modal, routeId, vaultDate }) => {
            this.ShipmentService.makeDeliverable(shipment.trackingId, routeId, vaultDate, this.User.getUser().id, shipment.branchId)
                .then(() => {
                    modal.close();
                    this.getPickupShipmentList();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal(err.data.message);
                    }
                });
        }, ({ modal }) => {
            if (modal) modal.close();
        });
    }

    transferPickupToRoute(shipment) {
        this.Modal.shipmentNotPickedUp(shipment, ({ modal }) => {
            modal.close();
            this.getPickupShipmentList();
        }, ({ modal }) => {
            if (modal) modal.close();
        }, true);
    }

    markAsCheckedIn(shipment) {
        this.Modal.confirmSupervisor('mark-as-checked-in', shipment.trackingId, ({ modal, supId }) => {
            this.HoldService.shipmentHoldMarkCheckedIn(shipment.trackingId, supId, shipment.branchId, shipment.routeId)
                .then(() => {
                    modal.close();
                    this.filterPickupShipment();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal('error.' + err.data.message);
                    }
                })
        }, ({ modal }) => {
            modal.close();
        })
    }

    shiftBranch(userId, selectedBranch) {
        var obj = {
            id: userId,
            branchId: selectedBranch
        };

        return this.UsersService.updateUserBranch(obj.id, obj)
            .then((data) => {
                this.User.setUser(data);
            })
    }

    markUndelivered(shipmentObj) {
        this.Modal.confirmSupervisor('mark-as-undelivered', shipmentObj.trackingId, ({ modal, supId }) => {
            this.VaultOperationsService.shipmentMarkUndelivered(shipmentObj.trackingId, shipmentObj.routeId, supId, shipmentObj.branchId, shipmentObj.loadedAmount, shipmentObj.amount)
                .then(() => {
                    modal.close();
                    this.filterDeliveries();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal('error.' + err.data.message);
                    }
                })
        }, ({ modal }) => {
            modal.close();
        })
    }

    editPickupShipmentModal(shipmentObj) {
        const branchTimezone = this.model.timezone || this.model.setupDetails.timezone;

        this.Modal.editPickupShipment(shipmentObj, branchTimezone, ({ modal, shipments, $scope }) => {

            delete shipments.amount;
            delete shipments.deliveryTime;
            delete shipments.deliveryDate;
            delete shipments.vaultDate;
            delete shipments.loadedAmount;
            delete shipments.selectedRoute;
            delete shipments.selectedShipType;
            delete shipments.pickupDate;
            delete shipments.pickupTime;

            shipments.currentTimezone = this.model.timezone;

            $scope.model.loading = true;
            this.VaultOperationsService.updatePickupShipment(shipments)
                .then(() => {
                    modal.close();
                    this.getPickupShipmentList();
                })
                .catch((err) => {
                    modal.close();
                    this.Modal.errorModal('error.' + err.data.message)
                })
                .finally(() => {
                    $scope.model.loading = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })
    }

    shipmentCheckIn(shipment) {
        const trackingId = shipment.trackingId;
        this.Modal.confirmSupervisor('shipment-check-in', { trackingId: trackingId }, ({ modal, supId }) => {
            modal.close();

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('vaultOperations.confirm_shipment_check_in', { trackingId }),
                callback: (({
                    modal
                }) => {
                    return this.VaultOperationsService.shipmentCheckIn(shipment.branchId, trackingId, shipment.routeId, supId, this.formatDate(shipment.vaultDate))
                        .then(() => {
                            modal.close();
                            this.filterPickupShipment();
                        })
                        .catch((err) => {
                            modal.close();
                            if (err && err.data && err.data.message) {
                                return this.Modal.errorModal('error.' + err.data.message);
                            }
                        })
                }),
                type: 'success'
            })
        }, ({ modal }) => {
            modal.close();
        });
    }

    shipmentCheckInDelivery(shipment) {
        const trackingId = shipment.trackingId;
        this.Modal.confirmSupervisor('shipment-check-in-delivery', { trackingId: trackingId, showConvertToPickup: true }, ({ modal, supId, convertToPickup }) => {
            modal.close();

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('vaultOperations.confirm_shipment_check_in', { trackingId }),
                callback: (({
                    modal
                }) => {
                    return this.VaultOperationsService.shipmentCheckInDelivery(shipment.branchId, trackingId, shipment.routeId, supId, this.formatDate(shipment.vaultDate), convertToPickup)
                        .then(() => {
                            modal.close();
                            this.filterDeliveries();
                            if (convertToPickup) {
                                this.filterPickupShipment();
                            }
                        })
                        .catch((err) => {
                            modal.close();
                            this.loadingDeliveries = false;
                            this.filterDeliveries();
                            return this.Modal.errorModal(err.data.message);
                        })
                }),
                type: 'success'
            })
        }, ({ modal }) => {
            modal.close()
        })
    }

    isManualCheckoutBlocked(shipment) {
        const isBatchShipment = shipment && shipment.batchId && !shipment.orderNo;
        return !!(shipment
            && shipment.coinFlag
            && !shipment.coinDebited
            && !isBatchShipment);
    }

    shipmentCheckOut(shipment) {
        if (this.isManualCheckoutBlocked(shipment)) {
            return this.Modal.errorModal('error.E_COIN_MANUAL_CHECKOUT_NOT_ALLOWED');
        }

        const trackingId = shipment.trackingId;
        this.Modal.confirmSupervisor('shipment-check-out', { trackingId: trackingId }, ({ modal, supId }) => {
            modal.close();

            this.Modal.confirm({
                header: this.$translate.instant('common.confirm_title'),
                message: this.$translate.instant('vaultOperations.confirm_shipment_check_out', { trackingId }),
                callback: (({
                    modal
                }) => {
                    return this.VaultOperationsService.shipmentCheckOut(shipment.branchId, shipment.trackingId, shipment.routeId, supId, this.formatDate(shipment.vaultDate))
                        .then(() => {
                            modal.close();
                            this.filterDeliveries();
                        })
                        .catch((err) => {
                            modal.close();
                            if (err && err.data && err.data.message) {
                                return this.Modal.errorModal('error.' + err.data.message);
                            }
                        })
                }),
                type: 'success'
            })
        }, ({ modal }) => {
            modal.close();
        });
    }

    formatDate(date) {
        if (!date) return;
        return this.DateUtil.getUTCDate(date);
    }

    releaseItem(shipment, stats) {
        const trackingId = shipment.trackingId;

        this.UsersService.checkSupervisor(this.model.loggedInUser)
            .then((userInfo) => {
                this.Modal.holdReleases(shipment, !userInfo.supervisor, ({ supervisorId, comment, shipmentAssignedTo, selectedDate, routeInfo, modal }) => {
                    const date = moment(selectedDate).format('YYYY-MM-DD');

                    this.ShipmentService.holdRelease(trackingId, shipment.routeId, shipmentAssignedTo, date, userInfo.supervisor ? userInfo.id : supervisorId, comment, shipment.branchId)
                        .then(() => {
                            modal.close();
                            if (stats === 'Deliveries') {
                                this.filterDeliveries();
                            }
                            else if (stats === 'Pickups') {
                                this.filterPickupShipment();
                            }
                        })
                        .catch((err) => {
                            if (err && err.data && err.data.message) {
                                return this.Modal.errorModal("error." + err.data.message);
                            }
                        })
                        .finally(() => {
                            modal.close();
                        })
                }, ({ modal }) => {
                    if (modal) modal.close();
                });
            })
            .catch((err) => {
                this.Modal.errorModal(err.data.message);
            })
    }

    getSelectedBranches() {
        return Array.isArray(this.model.selectedBranch) ? this.model.selectedBranch.map((branch) => branch.branchId) : null;
    }

    canReleaseForCount(shipment) {
        return !!(shipment && shipment.holdFlag && shipment.canReleaseForCount === 1);
    }

    isParentResidualPickup(shipment) {
        return !!(shipment && 
            !shipment.bagSeal && 
            !shipment.isRequiredPickup && 
            !shipment.isParentDelivery && 
            shipment.orderNo);
    }

    releaseForCount(shipment) {
        if (this.model.loading) return;
        this.model.loading = true;

        this.Modal.confirmSupervisor('release-for-count', shipment.trackingId, ({ modal, supId }) => {
            const defaultComment = 'Released for count';
            this.HoldService.releaseForCount(shipment.trackingId, shipment.routeId, supId, defaultComment)
                .then(() => {
                    modal.close();
                    this.filterPickupShipment();
                    this.model.loading = false;
                })
                .catch((err) => {
                    modal.close();
                    this.model.loading = false;
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal('error.' + err.data.message);
                    }
                });
        }, ({ modal }) => {
            if (modal) modal.close();
            this.model.loading = false;
        });
    }

    // -------------------------------------------Pickup/Residual Shipment Logic section End------------------------------------------------ //

    restrictShipmentUpdate(shipmentVaultDate, branchCurrentVaultDate) {
        return moment(shipmentVaultDate).isBefore(branchCurrentVaultDate);
    }

    softDeleteShipment(shipment, stats) {
        if (this.isSoftDeleting) return;
        this.isSoftDeleting = true;

        this.Modal.deletedReason(shipment, ({ supervisorId, reason, modal }) => {
            this.ShipmentService.softDeleteShipment(shipment.shipmentId, shipment.branchId, reason, supervisorId)
                .then(() => {
                    modal.close();
                    if (stats === 'Deliveries') this.filterDeliveries();
                    else if (stats === 'Pickups') this.filterPickupShipment();
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal('error.' + err.data.message);
                    }
                })
                .finally(() => {
                    this.isSoftDeleting = false;
                })
        }, ({ modal }) => {
            if (modal) modal.close();
            this.isSoftDeleting = false;
        });
    }

    markUndeliveredWithCRV(shipmentObj) {        
        if (!shipmentObj.orderType) {
            this.Modal.confirmSupervisor('mark-as-undelivered', { trackingId: shipmentObj.trackingId }, ({ modal, supId }) => {
                modal.close();
                
                // Process undelivered directly for COD
                this.VaultOperationsService.shipmentMarkUndelivered(
                    shipmentObj.trackingId, 
                    shipmentObj.routeId, 
                    supId, 
                    shipmentObj.branchId, 
                    shipmentObj.loadedAmount, 
                    shipmentObj.amount,
                    shipmentObj.reason,
                    shipmentObj.fromLocationId, 
                    shipmentObj.toLocationId, 
                    shipmentObj.qty, 
                    shipmentObj.shiptypeId
                )
                .then(() => {
                    this.getDeliveryShipmentList();
                })
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal('error.' + err.data.message);
                    }
                });
            }, ({ modal }) => {
                modal.close();
            });
            return;
        }

        this.Modal.markUndeliveredWithCRV(shipmentObj, ({ modal, convertToCRV, $scope, reason }) => {
            shipmentObj.reason = reason;
            this.checkAndCallSupervisor(shipmentObj, convertToCRV)
                .then((obj) => {
                    if (!convertToCRV) {
                        return this.markShipmentAsUndelivered(shipmentObj, obj.supId).then(() => {
                            modal.close();
                            this.getDeliveryShipmentList();
                        })
                    }

                    return this.converToCRVAndMarkAsUndelivered(shipmentObj, modal);
                })
                .catch((err) => {
                    modal.close();
                    if (err && err.data && err.data.message) {
                        return this.Modal.errorModal('error.' + err.data.message);
                    }
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        });
    }

    markShipmentAsUndelivered(shipmentObj, supId) {
        return this.VaultOperationsService.shipmentMarkUndelivered(shipmentObj.trackingId, shipmentObj.routeId, supId, shipmentObj.branchId, shipmentObj.loadedAmount, shipmentObj.amount, shipmentObj.reason, shipmentObj.fromLocationId, shipmentObj.toLocationId, shipmentObj.qty, shipmentObj.shiptypeId)
    }

    converToCRVAndMarkAsUndelivered(shipmentObj, markUndeliveredWithCRVModal) {
        this.Modal.convertToCrv(shipmentObj, true, false, ({ supervisor, trackingIdResidual, modal }) => {
            return this.markShipmentAsUndelivered(shipmentObj, supervisor)
                .then(() => this.HoldService.convertToCRV(shipmentObj.branchId, shipmentObj.trackingId, trackingIdResidual, supervisor))
                .catch((err) => {
                    if (err && err.data && err.data.message) {
                        this.Modal.errorModal('error.' + err.data.message);
                    }
                })
                .finally(() => {
                    modal.close();
                    if (markUndeliveredWithCRVModal) markUndeliveredWithCRVModal.close();
                    this.getDeliveryShipmentList();
                })
        }, ({ modal }) => {
            if (modal) modal.close();
        })

    }

    checkAndCallSupervisor(shipments, convertToCRV) {
        let defer = this.$q.defer();

        let needSupervisor = true;
        if (convertToCRV) needSupervisor = false;

        if (needSupervisor) {
            this.Modal.confirmSupervisor('mark-as-undelivered', { trackingId: shipments.trackingId }, ({ modal, supId }) => {
                modal.close();
                defer.resolve({ needSupervisor, supId });
            }, ({ modal }) => {
                modal.close();
                defer.reject({ needSupervisor });
            })
        }
        else {
            defer.resolve({ needSupervisor });
        }

        return defer.promise;
    }

    isPastVaultDate(routeDate, branchCurrentVaultDate) {
        return moment(routeDate).isSame(branchCurrentVaultDate);
    }

    undoCheckInTime(obj) {
        this.Modal.confirm({
            header: this.$translate.instant('common.confirm_title'),
            message: this.$translate.instant('vaultOperations.confirm_undo_check_in_time', { routeId: obj.routeId }),
            callback: (({
                modal
            }) => {
                this.VaultOperationsService.undoCheckInTime(obj.routeId, this.formatDate(obj.routeDate), obj.branchId)
                    .then(() => {
                        modal.close();
                        this.getRouteList();
                    })
                    .catch((err) => {
                        modal.close();
                        if (err && err.data && err.data.message) {
                            this.Modal.errorModal(err.data.message);
                        }
                    })
            }),
            type: 'danger'
        }, ({ modal }) => {
            modal.close();
        });
    }

    getSoftDeleteShipmentPermission() {
        this.UsersService.validateUserPermissions(this.User.getUser().firstName, this.User.getUser().lastName)
            .then((permissions) => {
                this.hasSoftDeleteShipmentPermission = (permissions.hasSoftDeleteShipmentPermission || this.CommonLayoutService.isAllowToAccessPages());
            })
            .catch((err) => {
                console.log(err);
            });
    };

    isShipmentCounted(shipment) {
        return shipment && shipment.countCompletedAt;
    }

    rescheduleDeliveries(routeObj) {
        this.Modal.rescheduleDeliveries(routeObj, ({ modal, routeId, vaultDate, shipments, supervisorId }) => {
            this.VaultOperationsService.rescheduleRouteDeliveries(
                routeObj.routeId, this.formatDate(routeObj.routeDate),
                routeId, vaultDate, routeObj.branchId,
                `Rescheduled Delivery to Route ${routeId} on ${vaultDate}`,
                shipments, supervisorId
            ).then((res) => {
                modal.close();
                if (res.status) {
                    this.Modal.successModal({
                        header: 'Success',
                        message: res.message,
                        buttons: ['common.ok'],
                        callback: ({ modal: successModal }) => {
                            successModal.close();
                            this.getRouteList();
                        },
                        negative: ({ modal: successModal }) => {
                            successModal.close();
                            this.getRouteList();
                        }
                    });
                } else {
                    this.Modal.errorModal('error.' + res.message);
                }
            }).catch((err) => {
                modal.close();
                if (err && err.data && err.data.message) {
                    this.Modal.errorModal('error.' + err.data.message);
                }
            });
        }, ({ modal }) => {
            if (modal) modal.close();
        });
    }

    markAllDelivered(routeObj) {
        this.Modal.markAllDeliveredListModal(
            routeObj.routeId,
            this.formatDate(routeObj.routeDate),
            routeObj.branchId,
            this.VaultOperationsService,
            ({ modal: listModal, shipments }) => {
                listModal.close();

                this.Modal.confirmSupervisor('mark-all-delivered', { routeId: routeObj.routeId }, ({ modal: supervisorModal, supId }) => {
                    this.loading = true;
                    this.VaultOperationsService.markAllDelivered(routeObj.branchId, routeObj.routeId, this.formatDate(routeObj.routeDate), supId)
                        .then(() => {
                            this.getRouteList();
                            this.getDeliveryShipmentList();
                            supervisorModal.close();
                        })
                        .catch((err) => {
                            if (err && err.data && err.data.message) {
                                this.Modal.errorModal('error.' + err.data.message);
                            } else {
                                this.Modal.errorModal('An error occurred while marking all as delivered.');
                            }
                            supervisorModal.close();
                        })
                        .finally(() => {
                            this.loading = false;
                        });
                }, ({ modal: supervisorModal }) => {
                    if (supervisorModal) supervisorModal.close();
                });
            },
            ({ modal: listModal }) => {
                if (listModal) listModal.close();
            }
        );
    }


}

export default VaultOperationsController;



// WEBPACK FOOTER //
// ./client/app/components/vault_operations/vault_operations.controller.js